import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconAdd, IconAnimation, IconApps, IconBeachAccess, IconCleanHands, IconCreditCard, IconFitnessCenter, IconHotel, IconHotelFront, IconLeaf, IconPersonPlay, IconPool, IconRestaurant, IconRoom, IconSailing, IconSpa, IconPlayCircle } from '@travel-frontend/icons';
import { memoize } from 'lodash';
const iconMapping = {
  // Mapping for S3 JSON
  type: IconHotelFront,
  hotel: IconHotelFront,
  wellness: IconSpa,
  children: IconPersonPlay,
  eco: IconLeaf,
  pool: IconPool,
  beach: IconBeachAccess,
  sports: IconFitnessCenter,
  'water sports': IconSailing,
  'restaurants/food': IconRestaurant,
  animation: IconAnimation,
  near: IconRoom,
  // Mapping for Invia attributes Hotel Content API
  'IT03-TYPE': IconHotelFront,
  'IT03-HOT': IconHotelFront,
  'IT03-WELL': IconSpa,
  'IT03-CHI': IconPersonPlay,
  'IT03-POOL': IconPool,
  'IT03-BEA': IconBeachAccess,
  'IT03-SPO': IconFitnessCenter,
  'IT03-WSPO': IconSailing,
  'IT03-REST': IconRestaurant,
  'IT03-ANI': IconAnimation,
  'IT03-NEA': IconRoom,
  'IT03-DIS': IconRoom,
  // Additional mapping for supplier attributes in Hotel Content API sections
  facilities: IconHotelFront,
  propertyInfo: IconHotelFront,
  paymentOptions: IconCreditCard,
  location: IconRoom,
  board: IconRestaurant,
  entertainment: IconAnimation,
  miscellaneous: IconApps,
  rooms: IconHotel,
  hygiene: IconCleanHands,
  default: IconAdd,
  richMedia: IconPlayCircle
};
export const getIconByName = memoize(name => {
  if (iconMapping[name]) {
    return iconMapping[name];
  }
  return null;
});
export const SectionIcon = /*#__PURE__*/_styled(({
  name,
  ...restProps
}) => {
  const Icon = getIconByName(name);
  if (!Icon) {
    return null;
  }
  return _jsx(Icon, {
    ...restProps
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1exbiy40"
} : {
  target: "e1exbiy40",
  label: "SectionIcon"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");